import _ from "lodash";
import I18n from "../../../../../../../../i18n";

const getPrimaryChainOptions = () => ({
    // Cadenas de Tronco y Cuello
    "torso_front": I18n.t('practice.primaryChainOptions.torso_front'),
    "torso_rear": I18n.t('practice.primaryChainOptions.torso_rear'),
    "neck_front": I18n.t('practice.primaryChainOptions.neck_front'),
    "neck_rear": I18n.t('practice.primaryChainOptions.neck_rear'),
    "scapular_girdle": I18n.t('practice.primaryChainOptions.scapular_girdle'),
    "pelvic_girdle": I18n.t('practice.primaryChainOptions.pelvic_girdle'),

    // Extremidades Superiores
    "right_arm_front": I18n.t('practice.primaryChainOptions.right_arm_front'),
    "right_arm_rear": I18n.t('practice.primaryChainOptions.right_arm_rear'),
    "left_arm_front": I18n.t('practice.primaryChainOptions.left_arm_front'),
    "left_arm_rear": I18n.t('practice.primaryChainOptions.left_arm_rear'),
    "right_arm_int": I18n.t('practice.primaryChainOptions.right_arm_int'),
    "right_arm_ext": I18n.t('practice.primaryChainOptions.right_arm_ext'),
    "left_arm_int": I18n.t('practice.primaryChainOptions.left_arm_int'),
    "left_arm_ext": I18n.t('practice.primaryChainOptions.left_arm_ext'),

    // Extremidades Inferiores
    "right_leg_front": I18n.t('practice.primaryChainOptions.right_leg_front'),
    "right_leg_rear": I18n.t('practice.primaryChainOptions.right_leg_rear'),
    "left_leg_front": I18n.t('practice.primaryChainOptions.left_leg_front'),
    "left_leg_rear": I18n.t('practice.primaryChainOptions.left_leg_rear'),
    "right_leg_int": I18n.t('practice.primaryChainOptions.right_leg_int'),
    "right_leg_ext": I18n.t('practice.primaryChainOptions.right_leg_ext'),
    "left_leg_int": I18n.t('practice.primaryChainOptions.left_leg_int'),
    "left_leg_ext": I18n.t('practice.primaryChainOptions.left_leg_ext')
});

const getContraindicationsOptions = () => ({
    // ZONA LUMBAR (Referencia Matriz: torso_rear / pelvic_girdle)
    "lumbar.withInjury.hernia": I18n.t('practice.contraindicationsOptions.lumbar.withInjury.hernia'),
    "lumbar.withInjury.scoliosis": I18n.t('practice.contraindicationsOptions.lumbar.withInjury.scoliosis'),
    "lumbar.withInjury.osteoporosis": I18n.t('practice.contraindicationsOptions.lumbar.withInjury.osteoporosis'),
    "lumbar.withInjury.stenosis": I18n.t('practice.contraindicationsOptions.lumbar.withInjury.stenosis'),
    "lumbar.withInjury.radiculopathy": I18n.t('practice.contraindicationsOptions.lumbar.withInjury.radiculopathy'),
    "lumbar.withInjury.spondylolisthesis": I18n.t('practice.contraindicationsOptions.lumbar.withInjury.spondylolisthesis'),
    "lumbar.withInjury.osteoarthritis": I18n.t('practice.contraindicationsOptions.lumbar.withInjury.osteoarthritis'),

    // ZONA CERVICAL (Referencia Matriz: neck_rear)
    "cervical.withInjury.hernia": I18n.t('practice.contraindicationsOptions.cervical.withInjury.hernia'),
    "cervical.withInjury.osteoarthritis": I18n.t('practice.contraindicationsOptions.cervical.withInjury.osteoarthritis'),
    "cervical.withInjury.hyperlordosis": I18n.t('practice.contraindicationsOptions.cervical.withInjury.hyperlordosis'),
    "cervical.withInjury.stenosis": I18n.t('practice.contraindicationsOptions.cervical.withInjury.stenosis'),

    // HOMBROS (Referencia Matriz: scapular_girdle / arms)
    "shoulders.withInjury.bursitis": I18n.t('practice.contraindicationsOptions.shoulders.withInjury.bursitis'),
    "shoulders.withInjury.tear": I18n.t('practice.contraindicationsOptions.shoulders.withInjury.tear'),
    "shoulders.withInjury.rotatorCuffTendinitis": I18n.t('practice.contraindicationsOptions.shoulders.withInjury.rotatorCuffTendinitis'),
    "shoulders.withInjury.frozen": I18n.t('practice.contraindicationsOptions.shoulders.withInjury.frozen'),
    "shoulders.withInjury.fracture": I18n.t('practice.contraindicationsOptions.shoulders.withInjury.fracture'),

    // RODILLAS (Referencia Matriz: legs_front / legs_rear)
    "knees.withInjury.patellarChondropathy": I18n.t('practice.contraindicationsOptions.knees.withInjury.patellarChondropathy'),
    "knees.withInjury.meniscalTear": I18n.t('practice.contraindicationsOptions.knees.withInjury.meniscalTear'),
    "knees.withInjury.arthritis": I18n.t('practice.contraindicationsOptions.knees.withInjury.arthritis'),
    "knees.withInjury.tendinitis": I18n.t('practice.contraindicationsOptions.knees.withInjury.tendinitis'),

    // PELVIS Y CADERA (Referencia Matriz: pelvic_girdle)
    "pelvis.withInjury.sacro-ileitis": I18n.t('practice.contraindicationsOptions.pelvis.withInjury.sacro-ileitis'),
    "pelvis.withInjury.pubalgia": I18n.t('practice.contraindicationsOptions.pelvis.withInjury.pubalgia'),
    "pelvis.withInjury.sciatica": I18n.t('practice.contraindicationsOptions.pelvis.withInjury.sciatica'),
    "pelvis.withInjury.femoro-acetabularImpingement": I18n.t('practice.contraindicationsOptions.pelvis.withInjury.femoro-acetabularImpingement'),

    // CONDICIONES GENERALES (Filtros de Seguridad no biométricos)
    "general.hypertension": I18n.t('practice.contraindicationsOptions.general.hypertension'),
    "general.glaucoma": I18n.t('practice.contraindicationsOptions.general.glaucoma'),
    "general.pregnancy": I18n.t('practice.contraindicationsOptions.general.pregnancy')
});

// Exportar constantes que ejecutan las funciones
export const primaryChainOptions = getPrimaryChainOptions();
export const primaryChainSelectOptions = _.map(primaryChainOptions, (text, value) => ({ key: value, text, value }));
export const contraindicationsOptions = getContraindicationsOptions();

// Exportar las funciones también para permitir actualización de traducciones en tiempo de ejecución
export { getPrimaryChainOptions, getContraindicationsOptions };